import React from 'react';

import { subscribe_path } from '../../routes';
import Button from '../BaseUI/Button';

const FooterSection = ({ isSubscriber }: { isSubscriber: boolean }) => {
  return (
    <div className="flex flex-col items-center justify-center mt-24 px-16 lg:px-0">
      <div className="font-serif font-medium text-headline-lg md:text-headline-xl text-pro-red text-center">
        Read The Information first...
      </div>
      <div className="font-serif font-medium text-headline-lg text-center">
        or <span className="italic">them</span> later
      </div>
      <div className="font-serif text-style font-normal body-lg text-[#545B69] text-center sm:max-w-[520px] mb-32">
        The Information is where you go to get the most important news about technology and business
        first.
      </div>
      {!isSubscriber && (
        <Button
          className="mt-8 mb-48 w-[240px] !capitalize text-sans !text-body-lg"
          rounded="slight"
          type="button"
          variant="primary"
          href={subscribe_path()}
        >
          Subscribe
        </Button>
      )}
    </div>
  );
};

export default FooterSection;
